// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-tabs";
import "./../bindings/bao-tree";
import "./../services/bao-router";
import "./../factories/tree-node";
import "./../services/bao-menu";
import "./../factories/bao-dialog";
import "./../bindings/bao-searcher";
import "./../factories/reminder-ticket-send-mail-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import SendEmailDialog from "./../factories/reminder-ticket-send-mail-dialog";
import BaoDialogViewModel from "./../factories/bao-dialog";
import TicketAuditDialog from "./../factories/ticket-audit-dialog";
import AppTabController from "../services/app-tab-controller";

import TreeNodeViewModel from "../factories/tree-node";
import baoRouter from "../services/bao-router";
import baoMenu from "../services/bao-menu";
import { CheckwareTaskTypes } from "../constants/checkware-task-types";

export class ReminderTicketTemplateDialog {
    Dialog = null;
    Bao = Bao;
    SelectedItem = ko.observable();
    Items = ko.observableArray();
    Deferred = $.Deferred();
    constructor() { }
    SelectItem = (item) => {
        this.Deferred.resolve(item);
        if (this.Dialog != null && this.Dialog.Close != null) {
            this.Dialog.Close();
        }
    };
    OpenDialog = () => {
        this.Bao.post("ReminderTicketTemplate/SelectReminderTicketTemplateDialog", (result) => {
            if (result.Models != null && result.Models.length > 0) {
                this.Dialog = new BaoDialogViewModel(this.Bao.Session.ApplicationName);
                this.Items(result.Models);
                this.Dialog.ViewModel(this);
                this.Dialog.Buttons([
                    {
                        Title: this.Bao.Session.GetMessage("msgOk"),
                        Click: () => {
                            this.Deferred.resolve(this.SelectedItem());
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    },
                    {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: () => {
                            // say the deferred its canceled! dont open any new info
                            this.Deferred.resolve(false);
                            this.Dialog.Close(false);
                        },
                        Enabled: ko.observable(true)
                    }
                ]);
                this.Dialog.Closed = () => {
                    // say the deferred its canceled! dont open any new info
                    this.Deferred.resolve(false);
                };
                this.Dialog.Template(result.Message);
                this.Dialog.Open();
            }
            else {
                // say the deferred its ok, but no template is chossen (=empty Template)
                this.Deferred.resolve({ TicketTemplateId: false });
            }
        });
        return this.Deferred.promise();
    };
}
class ReminderTicket extends BaseViewModel {
    _tabPage: TabPage;
    constructor(tabPage: TabPage) {
        super(tabPage);
        this._tabPage = tabPage;
        this.SelectedConfigurationItem.subscribe(() => {
            this.ConfigurationItemChanged(this.SelectedConfigurationItem());
        });
        this.OwnerServiceProviderId.subscribe((value) => {
            if (value == null) {
                this.OwnerPersonId(null);
                this.OwnerPersonName("");
                this.OwnerPersonSerachEnabled(false);
            }
            else {
                this.OwnerPersonSerachEnabled(true);
            }
        });
        this.TicketStatusId.subscribe((value) => {
            if (this.ChangeFirstTime() == true) {
                this.OldTicketStatusId(this.TicketStatusId());
                this.ChangeFirstTime(false);
            }
        });
        this.CheckwareTaskActivated.subscribe((value) => {
            if (value && !ko.unwrap(this.CheckwareTaskTypeId)) {
                this.CheckwareTaskTypeId(CheckwareTaskTypes.OneRecipientCompletesTask);
            }
        });
        this.ChooseAPerson.subscribe((value) => {
            if (value != null) {
                if (value.toString() == "0") { //Person übernehmen
                    if (!ko.unwrap(this.AffectedConfigurationItemName)) {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSelectedObjectOrNoOwner"), "info");
                    }
                    else { 
                        Bao.post("ConfigurationItem/GetOwnerFromObject", JSON.stringify({
                            configurationItemId: this.AffectedConfigurationItemId()
                        }))
                            .then((value) => {
                                if (value && value.Id) {
                                    this.TicketGenerationAffectedPersonId(value.Id);
                                    this.TicketGenerationAffectedPersonName(value.Name);
                                }
                                else {
                                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSelectedObjectOrNoOwner"), "info");
                                }
                                this.TicketGenerationAffectedPersonEnabled(false);
                            });
                    }
                }
                else {
                    this.TicketGenerationAffectedPersonEnabled(true);
                }
            }
        });
        this.TabPage.MenuEvents.push(baoMenu.registerEvent((value) => {
            if (tabPage.IsActiveTab() == true) {
                switch (value.ActionKey()) {
                    case "ReminderTicketReport":
                        this.GenerateReport();
                        break;
                    case "ReminderTicketEmailReport":
                        this.EmailReport();
                        break;
                }
            }
        }));
    }
    TicketId: KnockoutObservable<string>;
    IsClosed: KnockoutObservable<boolean>;
    MenuClick = (action) => {
        if (this.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "ReminderTicketHistory":
                    this.OpenHistoryDialog();
                    break;
                case "ReminderTicketGenerateReminderTicketTemplate":
                    this.GenerateReminderTicketTemplate();
                    break;
                case "ReminderTicketAuditTrail":
                    this.OpenAuditTrail();
                    break;
            }
        }
    };
    CompleteCheck() {
        var isComplete: boolean = true;
        if (this.TicketTypeId() == null || this.TicketStatusId() == null || this.ProblemShort() == null || this.ProblemShort() == "" || this.TicketServiceStructureId() == null || this.TargetDateJs() == null || this.TargetDateJs() == "") {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(this.AffectedConfigurationItemId())) {
            isComplete = false;
        }
        if (this.CheckwareTaskActivated() && (this.CheckwareTaskForerun() == null || this.FolderStructureChecklistId() == null || this.CheckwareTaskTypeId() == null)) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "ReminderTicket/Init";
    }
    Bao = Bao;
    DocumentTab: TabPage;
    ChecklistTab: TabPage;
    ProblemShort = ko.observable<string>();
    //Ticket: -> Service von Reminder
    TicketServiceStructureName: KnockoutObservable<string> = ko.observable("");
    TicketServiceStructureId: KnockoutObservable<string> = ko.observable("");

    showUserTaggingControl: KnockoutObservable<boolean> = ko.observable(true);

    ProblemRawValue: KnockoutObservable<string> = ko.observable("")
    ProblemUserTaggingList: KnockoutObservableArray<string> = ko.observableArray([]);

    SolutionRawValue: KnockoutObservable<string> = ko.observable("")
    SolutionUserTaggingList: KnockoutObservableArray<string> = ko.observableArray([]);

    GoToOwnerServiceProvider = () => {
        if (this.OwnerServiceProviderId() != "") {
            baoRouter.setHash("#serviceprovider/" + this.OwnerServiceProviderId());
        }
    };
    GoToOwnerPerson = () => {
        if (this.OwnerPersonId() != "") {
            baoRouter.setHash("#person/" + this.OwnerPersonId());
        }
    };
    GoToContract = () => {
        if (this.ContractId() != "") {
            baoRouter.setHash("#contract/" + this.ContractId());
        }
    };
    GoToConfigurationItem = () => {
        if (this.AffectedConfigurationItemOpenUrl() != "") {
            baoRouter.setHash(this.AffectedConfigurationItemOpenUrl());
        }
    };
    //Objekt-Tab:
    AffectedConfigurationItemId = ko.observable<string>();
    SelectedConfigurationItem = ko.observable<string>();
    AffectedConfigurationItemOpenUrl = ko.observable<string>();
    AffectedConfigurationItemName: KnockoutObservable<string> = ko.observable<string>(); //Name
    ConfigurationItemTypeCategoryKey: KnockoutObservable<string> = ko.observable<string>();
    AffectedConfigurationItemType: KnockoutObservable<string> = ko.observable<string>(); //Objekt-art
    AffectedConfigurationItemCustomerName: KnockoutObservable<string> = ko.observable<string>(); //Kunde
    AffectedConfigurationItemBuilding: KnockoutObservable<string> = ko.observable<string>(); //Gebäude
    GotoAffectedConfigurationItemVisible = ko.computed(() => {
        return this.AffectedConfigurationItemId() != null && Bao.Session.HasPermission('ConfigurationItemSearch', '1A38B671-948C-42EE-B80D-F6B9A12814B6');
    });
    ConfigurationItemDeleted = () => {
        this.AffectedConfigurationItemName("");
        this.AffectedConfigurationItemType("");
        this.AffectedConfigurationItemCustomerName("");
        this.AffectedConfigurationItemBuilding("");
        this.AffectedConfigurationItemOpenUrl("");
    };
    SearcherConfigurationItem: Bindings.baoSearcher = {
        ObjectId: this.AffectedConfigurationItemId,
        ObjectValue: 'Name1',
        SearchType: 'ConfigurationItemAll',
        SelectedItem: this.SelectedConfigurationItem,
        ValueDeleted: this.ConfigurationItemDeleted,
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: this.GotoAffectedConfigurationItemVisible,
        Goto: this.GoToConfigurationItem
    };
    ConfigurationItemChanged(item) {
        if (item !== null) {
            this.AffectedConfigurationItemName(item.Name1);
            this.AffectedConfigurationItemType(item.ConfigurationItemTypeName);
            this.AffectedConfigurationItemCustomerName(item.CustomerName);
            this.AffectedConfigurationItemBuilding(item.BuildingName);
            this.AffectedConfigurationItemOpenUrl(item.OpenUrl);
        }
    }
    ;
    //Checkware-Tab:
    FolderStructureChecklistId = ko.observable<string>();
    CheckwareTaskTypeId = ko.observable<string>();
    CheckwareTaskActivated = ko.observable<boolean>();
    CheckwareTaskForerun = ko.observable<number>();
    FolderStructureChecklistName: KnockoutObservable<string> = ko.observable<string>();
    CheckwareTaskId: KnockoutObservable<string> = ko.observable<string>();
    TaskNr = ko.observable();
    SearcherFolderStructureChecklist: Bindings.baoSearcher = {
        ObjectId: this.FolderStructureChecklistId,
        ObjectValue: 'ListName',
        SearchType: 'Checkware-FolderStructureChecklist',
        AutoComplete: true,
        AutoSearch: true
    };
    //Ticket-Tab:
    TicketGenerationTemplateDependsOnPerson: KnockoutObservable<boolean> = ko.observable<boolean>();
    TicketGenerationServiceStructureName: KnockoutObservable<string> = ko.observable("");
    TicketGenerationServiceStructureId: KnockoutObservable<string> = ko.observable("");
    TicketGenerationActivated = ko.observable();
    ChooseAPerson: KnockoutObservable<string> = ko.observable<string>();
    TicketGenerationPriorityId: KnockoutObservable<string> = ko.observable("");
    TicketGenerationPriorityName: KnockoutObservable<string> = ko.observable<string>();
    TicketGenerationStatusName: KnockoutObservable<string> = ko.observable<string>();
    TicketGenerationTypeId: KnockoutObservable<string> = ko.observable("");
    TicketGenerationTypeName: KnockoutObservable<string> = ko.observable<string>();
    TicketGenerationAffectedPersonId: KnockoutObservable<string> = ko.observable<string>();
    TicketGenerationAffectedPersonName: KnockoutObservable<string> = ko.observable<string>();
    SearcherTicketGenerationPriority: Bindings.baoSearcher = {
        ObjectId: this.TicketGenerationPriorityId,
        ObjectValue: 'Priority',
        AutoComplete: true,
        SearchType: 'TicketPriority',
        AutoSearch: true
    };
    SearcherTicketGenerationType: Bindings.baoSearcher = {
        ObjectId: this.TicketGenerationTypeId,
        ObjectValue: 'Type',
        AutoComplete: true,
        SearchType: 'TicketType',
        AutoSearch: true,
        CustomFilter: { TicketTypeCategoryId: "6414771f-3203-4e7a-a15c-d46185abdba7" } //Ticket
    };
    TicketGenerationAffectedPersonEnabled = ko.observable(true);
    SearcherTicketGenerationAffectedPerson: Bindings.baoSearcher = {
        ObjectId: this.TicketGenerationAffectedPersonId,
        ObjectValue: 'FullName',
        SearchType: 'Person',
        AutoComplete: true,
        AutoSearch: true,
        Enabled: this.TicketGenerationAffectedPersonEnabled
    };
    //Dates
    TargetDateJs = ko.observable<string>();
    BeginDateJs = ko.observable<string>();
    ClosedDateJs = ko.observable<string>();
    //Reminder
    TimeUnitId = ko.observable<string>();
    ReminderIntervall = ko.observable<number>();
    ReminderIntervalReadOnly = ko.observable(false);
    SearcherTimeUnit: Bindings.baoSearcher = {
        ObjectId: this.TimeUnitId,
        ObjectValue: 'Name',
        AutoComplete: true,
        SearchType: 'TimeUnit',
        AutoSearch: true,
        Enabled: !this.ReminderIntervalReadOnly()
    };
    //TicketStatus
    ChangeFirstTime = ko.observable(true);
    OldTicketStatusId = ko.observable<string>();
    TicketStatusId = ko.observable<string>();
    TicketStatusName: KnockoutObservable<string> = ko.observable<string>();
    SearcherReminderState: Bindings.baoSearcher = {
        ObjectId: this.TicketStatusId,
        ObjectValue: 'Status',
        SearchType: 'TicketStatus',
        AutoSearch: true,
        AutoComplete: true,
        CustomFilter: { TicketTypeCategoryId: "12374dc1-884e-4fea-a3bf-0b834b695fdf" } //Mastertasklist
    };
    //TicketType
    TicketTypeId = ko.observable<string>();
    TicketTypeName: KnockoutObservable<string> = ko.observable<string>();
    SearcherTicketType: Bindings.baoSearcher = {
        ObjectId: this.TicketTypeId,
        ObjectValue: 'Type',
        SearchType: 'TicketType',
        AutoSearch: true,
        AutoComplete: true,
        CustomFilter: { TicketTypeCategoryId: "12374dc1-884e-4fea-a3bf-0b834b695fdf" } //Mastertasklist
    };
    //Vertrag
    ContractId = ko.observable<string>();
    ContractName: KnockoutObservable<string> = ko.observable<string>();
    GotoContractVisible = ko.computed(() => {
        return this.ContractId() != null && Bao.Session.HasPermission('ContractSearch', '1A38B671-948C-42EE-B80D-F6B9A12814B6');
    });
    SearcherContract: Bindings.baoSearcher = {
        ObjectId: this.ContractId,
        ObjectValue: 'Name1',
        AutoComplete: true,
        AutoSearch: true,
        SearchType: 'Contract',
        GotoVisible: this.GotoContractVisible,
        Goto: this.GoToContract
    };
    //Dienstleister
    OwnerServiceProviderId = ko.observable<string>();
    OwnerServiceProviderName: KnockoutObservable<string> = ko.observable<string>();
    GotoOwnerServiceProviderVisible = ko.computed(() => {
        return this.OwnerServiceProviderId() != null && Bao.Session.HasPermission('ServiceProviderSearch', '1A38B671-948C-42EE-B80D-F6B9A12814B6');
    });
    SearcherServiceProvider: Bindings.baoSearcher = {
        ObjectId: this.OwnerServiceProviderId,
        ObjectValue: 'ServiceProvider',
        SearchType: 'ServiceProvider',
        AutoSearch: true,
        AutoComplete: true,
        GotoVisible: this.GotoOwnerServiceProviderVisible,
        Goto: this.GoToOwnerServiceProvider
    };
    //Person
    OwnerPersonSerachEnabled = ko.observable(false);
    OwnerPersonId = ko.observable<string>();
    GotoOwnerPersonVisible = ko.computed(() => {
        return this.OwnerPersonId() != null && Bao.Session.HasPermission('PersonSearch', '1A38B671-948C-42EE-B80D-F6B9A12814B6');
    });
    OwnerPersonName: KnockoutObservable<string> = ko.observable<string>();
    SearcherOwnerPerson: Bindings.baoSearcher = {
        ObjectId: this.OwnerPersonId,
        ObjectValue: 'FullName',
        SearchType: 'Person',
        CustomFilter: {
            ServiceProviderId: this.OwnerServiceProviderId
        },
        Enabled: this.OwnerPersonSerachEnabled,
        AutoSearch: true,
        AutoComplete: true,
        GotoVisible: this.GotoOwnerPersonVisible,
        Goto: this.GoToOwnerPerson
    };
    IsCompleteDefault: KnockoutObservable<boolean>;
    //DateTimeBox etc:
    DateTimeBoxBeginDate: Bindings.baoDateTimeBox = {
        value: this.BeginDateJs,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerBeginDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    DateTimeBoxBeginDateWithTime: Bindings.baoDateTimeBox = {
        value: this.BeginDateJs,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerBeginDateWithTime: Bindings.baoDateTimePicker = {
        mode: 'datetime'
    };
    //DateTimeBox etc:
    DateTimeBoxTargetDate: Bindings.baoDateTimeBox = {
        value: this.TargetDateJs,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerTargetDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    DateTimeBoxTargetDateWithTime: Bindings.baoDateTimeBox = {
        value: this.TargetDateJs,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerTargetDateWithTime: Bindings.baoDateTimePicker = {
        mode: 'datetime'
    };
    DateTimeBoxClosedDate: Bindings.baoDateTimeBox = {
        value: this.ClosedDateJs,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimePickerCompleteDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    DateTimeBoxClosedDateWithTime: Bindings.baoDateTimeBox = {
        value: this.ClosedDateJs,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimePickerCompleteDateWithTime: Bindings.baoDateTimePicker = {
        mode: 'datetime'
    };
    NumberBoxCheckwareTaskForerun: Bindings.baoNumberBox = {
        value: this.CheckwareTaskForerun,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    NumberBoxReminderInterval: Bindings.baoNumberBox = {
        value: this.ReminderIntervall,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    //
    //Dialog: Verlauf / Historie
    OpenHistoryDialog() {
        this.TabPage.IsLoading(true);
        Bao.post("ReminderTicket/ReminderTicketHistoryDialog", JSON.stringify({}), ((result) => {
            this.TabPage.IsLoading(false);
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result);
            dialog.Width("1600px");
            dialog.ViewModel(this.TicketId());
            dialog.Open();
            dialog.SetPosition();
            dialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    dialog.Close();
                }
            });
        }));
    }
    //ServiceDialog:
    OpenTreeDialog(type, tabtype) {
        this.TabPage.IsLoading(true);
        var ticketTypeCategoryIdFilter;
        if (tabtype == 'Reminder') {
            ticketTypeCategoryIdFilter = "12374dc1-884e-4fea-a3bf-0b834b695fdf"; //Mastertasklist
        }
        else {
            ticketTypeCategoryIdFilter = "6414771f-3203-4e7a-a15c-d46185abdba7"; //Ticket
        }
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: type,
            ticketTypeCategoryId: ticketTypeCategoryIdFilter
        }), (value) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var dialogViewModel: any = {};
            dialogViewModel.NodeToggled = function (node) {
                // LoadChildren if not loaded
                if (node.Loaded() == false) {
                    this.TabPage.IsLoading(true);
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({
                        type: type,
                        parentId: parentId,
                        ticketTypeCategoryId: ticketTypeCategoryIdFilter
                    }), (value) => {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                        this.TabPage.IsLoading(false);
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            var selectedServiceSubscription = dialogViewModel.SelectedService.subscribe(() => {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = () => {
                this.TabPage.IsLoading(true);
                var selectedNode;
                //ursprünglich switch
                selectedNode = dialogViewModel.SelectedService();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({ selectedTicketServiceId: selectedNode.Id() }), (result) => {
                            if (tabtype == "Reminder") {
                                this.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                                this.TicketServiceStructureId(result.TicketServiceStructureId);
                                this.OwnerPersonId(result.OwnerUserId);
                                this.OwnerPersonName(result.OwnerUserName);
                                this.OwnerServiceProviderId(result.OwnerRoleId);
                                this.OwnerServiceProviderName(result.OwnerRoleName);
                                dialog.Close();
                                this.TabPage.IsLoading(false);
                                selectedServiceSubscription.dispose();
                                selectedServiceSubscription = null;
                                dialogViewModel.SelectedService(null);
                            }
                            else {
                                this.InitializeDataBindingTicketGenerationServiceStructure(result.TicketServiceStructureId);
                                this.TicketGenerationServiceStructureId(result.TicketServiceStructureId);
                                this.TicketGenerationAffectedPersonId(result.OwnerUserId);
                                this.TicketGenerationAffectedPersonName(result.OwnerUserName);
                                dialog.Close();
                                this.TabPage.IsLoading(false);
                                selectedServiceSubscription.dispose();
                                selectedServiceSubscription = null;
                                dialogViewModel.SelectedService(null);
                            }
                        });
                    }
                }
                this.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                return null;
            };
            dialog.Width("500px");
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Open();
            this.TabPage.IsLoading(false);
            dialog.SetPosition();
        });
    }
    InitializeDataBindingTicketServiceStructure(id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({ id: id }), (value) => {
            this.TicketServiceStructureName(value);
        });
    }
    ;
    InitializeDataBindingTicketGenerationServiceStructure(id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({ id: id }), (value) => {
            this.TicketGenerationServiceStructureName(value);
        });
    }
    ;
    DeleteService = () => {
        this.TicketServiceStructureName(null);
        this.TicketServiceStructureId(null);
        this.OwnerPersonId(null);
        this.OwnerPersonName(null);
        this.OwnerServiceProviderId(null);
        this.OwnerServiceProviderName(null);
    }
    ;
    DeleteGenerationService() {
        this.TicketGenerationServiceStructureName(null);
        this.TicketGenerationServiceStructureId(null);
        this.TicketGenerationAffectedPersonId(null);
        this.TicketGenerationAffectedPersonName(null);
    }
    ;
    loaded() {
        this.OldTicketStatusId(this.TicketStatusId());
        this.ChooseAPerson("1");
        this.refreshUserTagging();
        return super.loaded();
    }
    init() {
        if (this.TabPage["Route"].InitData != null) {
            this.AffectedConfigurationItemId = this.TabPage["Route"].InitData;
        }
        if (this.TabPage.UrlData().id == null) {
            var reminderTicketTemplateDialog = new ReminderTicketTemplateDialog();
            return reminderTicketTemplateDialog.OpenDialog().then((reminderTicketTemplate: any) => {
                // cannot call super.InitTabController() here, getting configurationitemid from url has to be possible (generating reminder ticket for configuration item)
                if (reminderTicketTemplate) {
                    var reminderTicketTemplateId = reminderTicketTemplate.TicketTemplateId;
                    return this.InitConfigurationItem(reminderTicketTemplateId ? true : false, reminderTicketTemplateId);
                }
                else {
                    return super.init().then(() => {
                        return super.InitTabController().then(() => {
                            this.TabPage["$TabController"].RemoveTab(this.TabPage);
                        });
                    });
                }
            });
        }
        else {
            return this.InitConfigurationItem(false, null);
        }
    }
    InitConfigurationItem(initModelFromTemplate: boolean, reminderTicketTemplateId) {
        var configurationItemId = baoRouter.getRouteValue("configurationitemid", this.TabPage);
        this.OldTicketStatusId(this.TicketStatusId()); //TicketStatus für Speichern merken
        if (configurationItemId == null) {
            configurationItemId = this.AffectedConfigurationItemId();
        }
        baoMenu.registerEvent((action) => { this.MenuClick(action); });
        return super.init().then(() => {
            return super.InitTabController().then(() => {
                return this.initAffectedConfigurationItem(configurationItemId).then(() => {
                    this.DocumentTab = new TabPage();
                    this.DocumentTab.IsClosable(false);
                    this.DocumentTab.Url("ReminderTicketReferenceDocument");
                    this.TabController.AddTab(this.DocumentTab);
                    if (initModelFromTemplate) {
                        this.InitReminderTicketModel(reminderTicketTemplateId);
                    }
                });
            });
        });
    }
    InitReminderTicketModel(reminderTicketTemplateId) {
        console.log(this.TabPage.UrlData().id);
        return Bao.post("ReminderTicket/GetReminderTicketModelFromTemplate", JSON.stringify({
            id: this.TabPage.UrlData().id,
            reminderTicketTemplateId: reminderTicketTemplateId
        }), (model) => {
            ko.map.fromJS(model, this, this.TabPage.DirtyFlag);
            this.TabPage.SessionTabId = this.SessionTabId();
        });
    }
    //Laden der Daten für das Objekt Tab
    initAffectedConfigurationItem(configurationItemId) {
        return Bao.post("ReminderTicket/InitAffectedConfigurationItem", JSON.stringify({
            configurationItemId: configurationItemId
        }), (result) => {
            if (result != null && result != "") {
                this.AffectedConfigurationItemId(result.ConfigurationItemId);
                this.SelectedConfigurationItem(result);
                //this.ConfigurationItemChanged(result);
            }
            return result;
        });
    }
    MinimizeEntity() {
        let o = super.MinimizeEntity();
        // have to reset the object SessionId, because Refresh overwrote it and is now different to the tab's sessiontabid
        o.SessionTabId = this.TabPage.SessionTabId;
        return o;
    }
    GenerateReport() {
        // open ReportExplorer with PDF-report download-option of this file
        return Bao.post("SynosetReportCenter/GenerateReminderTicketReport", JSON.stringify({
            ticketId: this.TicketId(),
            reportTemplateId: null
        })).then((result) => {
            if (result.isCreated == true) {
                window.open(Bao.Content("BaoDocument/Download/" + result.message), "_blank");
            }
            else if (result.isCreated == false) {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.message, "info");
            }
        });
    }
    EmailReport() {
        this.TabPage.IsLoading(true);
        let dialog = new SendEmailDialog(this);
        dialog.Dialog();
    }
    GenerateReminderTicketTemplate() {
        let questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgGenerateTicketTemplate"), "yesno");
        questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                let newTab = new TabPage();
                newTab.Url("ReminderTicketTemplate");
                newTab["Object"] = {
                    ticketModel: ko.map.toJS(this, true)
                };
                AppTabController.AddTab(newTab);
            }
        });
    }
    ;
    OpenAuditTrail() {
        let ticketAuditDialog = new TicketAuditDialog(this.TicketId(), ko.unwrap(this.TabPage.Title), this._tabPage);
        ticketAuditDialog.Open();
    }
    private refreshUserTagging() {
        this.showUserTaggingControl(false);
        this.showUserTaggingControl(true);
    }
}
export default ReminderTicket;